import { regionCodeMap } from '@/consts'
import { fb_track_purchase, initPiexl, fb_track_lead } from '@/utils/fb-pixel'
import { tt_track_eventCommon } from '@/utils/tt-pixel'
import { COOKIE_TYPE, notInitLoadSDK } from '@/utils/cookieUtils'
import { getQuery } from '@/utils/utils'
import isEmpty from 'lodash/isEmpty'

const SOURCE_RANGE = 'XMFB'

export const orderFbTtTrack = ({
  result = {},
  region = '',
  eventName = '',
}) => {
  if (!isEmpty(result)) {
    let {
      currency = '',
      game = '',
      orderNo = '',
      payPrice = 0,
      skuId = '',
    } = result || {}
    let content_ids = `${regionCodeMap[region] || ''}${skuId}`
    let content_name = `${game}_${region}`
    let content_type = 'product'
    let contents = [{ id: skuId, quantity: 1 }]
    fb_track_purchase({
      content_ids,
      content_name,
      content_type,
      contents,
      currency,
      value: payPrice,
      orderNo,
    })
    tt_track_eventCommon({
      eventName: eventName,
      content_type,
      content_id: content_ids,
      content_category: content_name,
      currency,
      value: payPrice,
      quantity: 1,
      price: payPrice,
    })
  }
}

export const beginCheckoutTT = ({
  couponPayPrice = 0,
  gameName = '',
  region = '',
  currency = '',
  skuId = '',
}) => {
  const regionCode = regionCodeMap[region] || ''

  tt_track_eventCommon({
    eventName: 'PlaceAnOrder',
    content_type: 'product',
    content_id: `${regionCode}${skuId}`,
    content_category: `${gameName}_${region}`,
    currency,
    value: Number(couponPayPrice),
    quantity: 1,
    price: Number(couponPayPrice),
  })
}

export async function loginQuickSuccessFB(params = {}) {
  // 1.判断source
  const source = getQuery('source') || ''
  if (
    !(
      source &&
      source.toUpperCase &&
      source.toUpperCase().includes(SOURCE_RANGE)
    )
  ) {
    return
  }
  const { mode, login_way } = params
  // 2.判断mode === 1
  if (!(mode * 1 === 1)) {
    return
  }
  try {
    // 3.initFbPixel
    const result = await notInitLoadSDK([
      {
        form: COOKIE_TYPE.ADVERTISING,
        callback: initPiexl,
        id: '__fbevents__id',
      },
    ])
    // 4.打点上报
    if (result) {
      fb_track_lead({ content_name: login_way })
    }
  } catch (error) {
    // eslint-disable-next-line
    console.log(error)
  }
}
